import { render, staticRenderFns } from "./deliveryDelay.vue?vue&type=template&id=7ece6efa"
import script from "./deliveryDelay.vue?vue&type=script&lang=js"
export * from "./deliveryDelay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports